import SustainabilityHero from "./SustainabilityHero";

const SustainabilityHeroWithProps = ({ blok }) => {
  return <SustainabilityHero factoidCards={blok.factoidCards} />;
};

export default SustainabilityHeroWithProps;
